// extracted by mini-css-extract-plugin
var _1 = "LayoutMain-modulecollapsed__eBgJD";
var _2 = "LayoutMain-modulemain__Ao5op";
export { _1 as "collapsed", _2 as "main" }
